<template>
  <v-app>
    <v-main class="main-view">
      <Transition name="move-left">
        <router-view />
      </Transition>
    </v-main>
  </v-app>
</template>

<script>
import { Auth } from "../src/store/auth";
export default {
  name: "App",

  data: () => ({
    //
    Auth,
  }),
  async mounted() {
    const lang = localStorage.getItem("NoteLang");
    lang ? (this.$i18n.locale = lang) : "en";
    lang && lang == "ar"
      ? (this.$vuetify.rtl = true)
      : (this.$vuetify.rtl = false);
  },
  methods: {
    checkLang() {
      this.$vuetify.rtl = true;
      this.$i18n.locale = "ar";
      localStorage.setItem("NoteLang", "ar");
    },
  },
  created() {
    this.checkLang();
    if (!Auth.token) {
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@500&family=Montserrat:wght@400;500;600;700;800;900&display=swap");
* {
  font-family: Cairo, "sans-serif";
}
:root {
  --primary: #6f8faf;
}
.spinnero {
  position: absolute;

  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: whitesmoke;
}
.border {
  border: 2px solid var(--primary);
  border-radius: 5px;
  padding: 3px;
}
.main-view {
  background-color: whitesmoke;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
* {
  &::-webkit-scrollbar {
    width: 0px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>
